import { render, staticRenderFns } from "./orderreturnvisitrecord.vue?vue&type=template&id=cde5ab8a&scoped=true&"
import script from "./orderreturnvisitrecord.vue?vue&type=script&lang=js&"
export * from "./orderreturnvisitrecord.vue?vue&type=script&lang=js&"
import style0 from "./orderreturnvisitrecord.vue?vue&type=style&index=0&id=cde5ab8a&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cde5ab8a",
  null
  
)

export default component.exports